import { ENTITLEMENTS } from '../../application-core/constants';
import ExpandMore from '@material-ui/icons/ArrowDropDown';
import ExpandLess from '@material-ui/icons/ArrowDropUp';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import IconButton from '@material-ui/core/IconButton';
import DiscussionViewer from '../discussion/DiscussionViewer';
import Tooltip from '@material-ui/core/Tooltip';
import LangConfirmationField from '../LangConfirmationField';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import { STATUS_ACCEPTED, STATUS_REJECTED, STATUS_PENDING } from '../utils/constants';

const APPROVED = STATUS_ACCEPTED;
const REJECTED = STATUS_REJECTED;
const PENDING = STATUS_PENDING;

class PreviousTaskDisplay extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  expandTask = () => this.setState({ expanded: true });

  collapseTask = () => this.setState({ expanded: false });

  render() {

    const { data, classes, defaultLang, projectUsers, isReadOnly, entitlements } = this.props;
    const { assignedUser, assignedNote, user, created, hasDiscussion, status, inNamedGraph } = data;
    const { expanded } = this.state;
    const date = new Date(created);
    const dateText = date ? date.toLocaleString() : "";

    const foundAssignedUser = projectUsers.find(user => user.value === assignedUser);
    const assigned = assignedUser ?
      foundAssignedUser ?
        foundAssignedUser.label
        :
        "User not available"
      :
      "Unassigned";

    const usedStatus = status ?
      Array.isArray(status) ?
        status[0]
        :
        status
      :
      null;

    const userId = Array.isArray(user) ? user[0] : user;
    const foundCreatedUser = projectUsers.find(pu => pu.value === userId);
    const createdBy = foundCreatedUser ?
      foundCreatedUser.label
      :
      "User not available";

    return (
      <React.Fragment>
        <TableRow
          style={{
            backgroundColor: '#f5f5f5',
            color: '#888',
            borderBottom: expanded ? 'none' : 'solid 12px white'
          }}>
          <TableCell component="td" className={classes.tableCell}
            align='left'
            style={{ color: 'inherit' }}>
            <div style={{ display: 'flex' }}>
              <div>
                <AssignmentIndIcon style={{ transform: 'translateY(4px)', marginRight: 6 }} />
              </div>
              <div data-test="task-assignee" style={{ paddingTop: 6 }}>
                {assigned}
              </div>
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell}>
            {assignedNote && Object.keys(assignedNote).length > 0 &&
              <LangConfirmationField
                ariaLabel="Task instructions"
                dataTest="task-instructions"
                focus={false}
                disabled={true}
                multiline={true}
                text={assignedNote[Object.keys(assignedNote)[0]]}
                lang={Object.keys(assignedNote)[0]}
                isReadOnly={true} />
            }
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='left' style={{ color: 'inherit' }}>
            <div data-test="created-by" style={{ paddingTop: 6 }}>
              {createdBy}
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='left' style={{ color: 'inherit' }}>
            <div style={{ paddingTop: 6 }}>
              {dateText}
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='center'>
            <div data-test="task-date" style={{ paddingTop: 2 }}>
              {usedStatus !== REJECTED &&
                <Tooltip placement="right" title='Done'>
                  <span>
                    <AssignmentTurnedInIcon color={usedStatus === APPROVED ? "secondary" : "inherit"} />
                  </span>
                </Tooltip>
              }
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='center'>
            <div style={{ paddingTop: 2 }}>
              {usedStatus !== APPROVED &&
                <Tooltip placement="right" title='Rejected'>
                  <span>
                    <AssignmentReturnedIcon style={{ ...(usedStatus === REJECTED) && { color: '#DD2C00' } }} />
                  </span>
                </Tooltip>
              }
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='right'></TableCell>
          <TableCell component="td" className={classes.tableCell} align='left'>
            <div>
              {expanded ?
                <Tooltip title="Show less detail">
                  <IconButton size="small" onClick={this.collapseTask}>
                    <ExpandLess data-test="collapse" color="primary" />
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title="Show comments">
                  <IconButton size="small" onClick={this.expandTask}>
                    <ExpandMore data-test="expand" color="primary" />
                  </IconButton>
                </Tooltip>
              }
            </div>
          </TableCell>
        </TableRow>
        {expanded &&
          <TableRow
            style={{
              backgroundColor: usedStatus !== PENDING ?
                '#f5f5f5'
                :
                '#eeeeee',
              borderBottom: 'solid 12px white',
              borderRadius: 4
            }}>
            <TableCell colSpan={8} component="td" className={classes.tableCell} align='left'>
              {hasDiscussion
                && (entitlements.includes(ENTITLEMENTS.CREATE_DISCUSSION) || entitlements.includes(ENTITLEMENTS.VIEW_DISCUSSION))
                && hasDiscussion.map(discussion =>
                  <div key={discussion} style={{ backgroundColor: 'white', padding: '4px 12px 4px 12px', borderRadius: 4 }}>
                    <DiscussionViewer
                      isReadOnly={isReadOnly || usedStatus !== PENDING}
                      active={true}
                      displayNoComments={true}
                      defaultLang={defaultLang}
                      key={discussion}
                      id={discussion}
                      graph={inNamedGraph}
                      users={projectUsers} />
                  </div>
                )}
            </TableCell>
          </TableRow>
        }
      </React.Fragment>
    );
  }
}

PreviousTaskDisplay.propTypes = {
  classes: PropTypes.object,
  entitlements: PropTypes.array,
  data: PropTypes.object.isRequired,
  onTaskCompletion: PropTypes.func,
  currentUser: PropTypes.string.isRequired,
  assignedFilter: PropTypes.string,
  projectUsers: PropTypes.array.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(PreviousTaskDisplay);